import { updateTasks as _updateTasks } from '@griply/services';
import {
  collection,
  doc,
  Firestore,
  serverTimestamp,
  Timestamp,
  updateDoc,
  writeBatch,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { UpdateTask } from 'shared/types/task';

import { getAuthentication, getDatabase } from './helpers';

export const updateTasks = async (tasks: UpdateTask[]): Promise<void> => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  await _updateTasks({
    tasks,
    collection,
    doc,
    updateDoc,
    db: getDatabase(),
    serverTimestamp,
    timestampFromDate: Timestamp.fromDate,
    writeBatch: (_db) => writeBatch(_db as Firestore),
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.UpdateTasks,
        error,
        uid: user.uid,
      }),
  });
};
